var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.99,
    height: 16.088,
    viewBox: "0 0 26.99 16.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9395",
    "data-name": "Path 9395",
    d: "M13.495,98.725c-5.157,0-9.833,2.821-13.284,7.4a1.068,1.068,0,0,0,0,1.275c3.451,4.588,8.127,7.409,13.284,7.409s9.833-2.821,13.284-7.4a1.068,1.068,0,0,0,0-1.275C23.328,101.546,18.651,98.725,13.495,98.725Zm.37,13.709a5.677,5.677,0,1,1,5.295-5.295A5.68,5.68,0,0,1,13.865,112.434Zm-.171-2.617a3.057,3.057,0,1,1,2.854-2.854A3.052,3.052,0,0,1,13.694,109.817Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b59edcebae30ebbbcc59c60d809b9c78.svg";
export { ForwardRef as ReactComponent };